import {useTask} from '@github-ui/agent-sessions/hooks/use-task'
import type {SessionState} from '@github-ui/agent-sessions/types/session'
import {isSessionState} from '@github-ui/agent-sessions/types/session'
import {generateTaskPathForRepo} from '@github-ui/agent-sessions/utils/generate-task-path'
import {getAPITaskState} from '@github-ui/agent-sessions/utils/task-helpers'
import {useMemo} from 'react'
import type {FixTaskInfo} from './FixFindingStatus'

export function useFixTask({taskId, taskBasePath}: {taskId?: string; taskBasePath: string}) {
  const {data: taskData, isError: taskIsError} = useTask({taskId})

  const fixTask: FixTaskInfo | undefined = useMemo(() => {
    if (!taskId) return undefined
    if (taskIsError) return {taskId, state: 'failed' as SessionState}
    if (!taskData) return {taskId, state: 'queued' as SessionState}
    const rawState = getAPITaskState(taskData)
    const state: SessionState = isSessionState(rawState) ? rawState : 'queued'
    return {taskId, state}
  }, [taskId, taskData, taskIsError])

  const taskUrl = useMemo(() => {
    if (!taskId) return undefined
    const url = generateTaskPathForRepo({repositoryNwo: taskBasePath.replace(/^\//, ''), taskId})
    return url || undefined
  }, [taskId, taskBasePath])

  return {taskData, fixTask, taskUrl}
}
